export class LinkModel {
  emoji: string
  title: string
  url: string

  constructor(obj: any = null) {
    this.emoji = obj?.emoji
    this.title = obj?.title
    this.url = obj?.url
  }

}
